import React from "react";
import { Row } from "antd";

const CustomRow = (props) => <Row {...props}>{props.children}</Row>;
export default CustomRow;
